import React, {Component} from 'react';
import {Button, Modal, Grid, Form} from 'semantic-ui-react';
import update from 'react-addons-update';

import {showToast} from "../../actions/ToastAction";
import connect from "react-redux/es/connect/connect";
import localDB from "../../data/localDB";
import {ticketDialog} from "../../actions/TicketDialogActions";
import TicketProducts from "./TicketProducts";
import TicketData from "../../data/TicketData";
import {selectTicket} from "../../actions/TicketSelectActions";
import MaskedInput from "react-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";

const moneyMask = createNumberMask({
    prefix: '$',
});

class TicketDialog extends Component {

    constructor() {
        super();

        this.state = {
            ticket: {
                id: null,
                name: ' ',
                price: '',
                has_expiration: true,
                expiration_days: 0,
                is_active: true,
                products:[]
            },
            sending: false,
            product: '',
            price_error: false,
            product_error: false,
            quantity_error: false,
            quantity: 1
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.ticket_dialog){
            this.setState({
                ticket:nextProps.ticket_dialog.ticket,
                price_error: false,
                product_error: false,
                quantity_error: false,
            });
        }
    }

    componentDidMount(){
        this.loadData();
    };

    loadData() {
        localDB.getDB('products').then(products => {
            let options = products.map(product => {return {key:product.id, value:product.id, text:product.name}});
            this.setState({options});
        });
    };

    handleNameChange = (event) => {
        let name = update(this.state, {
            ticket: {
                name: {
                    $set: event.target.value
                }
            }
        });
        this.setState(name);
    };

    handleExpirationDaysChange= (event) => {
        let expiration_days = update(this.state, {
            ticket: {
                expiration_days: {
                    $set: event.target.value
                }
            }
        });
        this.setState(expiration_days);
    };

    handlePriceChange = (event) => {
        let value = isNaN(parseFloat(event.target.value.replace(/\D/g, ''))) ? '':parseFloat(event.target.value.replace(/\D/g, ''));
        let name = update(this.state, {
            ticket: {
                price: {
                    $set: value
                }
            }
        });
        this.setState(name);
    };

    async handleSubmit(event) {
        event.preventDefault();
        if (this.state.ticket.name.trim() === "") {
            this.setState({name_error: true});
        } else if (this.state.ticket.price === "") {
            this.setState({price_error: true});
        } else {
            this.setState({sending: true});
            if (this.state.ticket.id) {
                TicketData.update(this.state.ticket, (res) => {
                    if (res.update) {
                        this.dispatchData(res.data, 'Tiquetera Actualizada!');
                    } else {
                        this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
                    }
                }).finally(() => this.setState({sending: false, open: false}))
                    .catch(() => this.props.showToast({message: 'Tenemos un problema!', type: 'error'}));
            } else {
                TicketData.add(this.state.ticket, (res) => {
                    if (res.add) {
                        this.dispatchData(res.data, 'Tiquetera Agregada!');
                    } else {
                        this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
                    }
                    this.setState({sending: false, open: false});
                }).finally(() => this.setState({sending: false, open: false}))
                    .catch(() => this.props.showToast({message: 'Tenemos un problema!', type: 'error'}));
            }
        }
    };

    handleHasExpiration = () => {
        let has_expiration = update(this.state, {
            ticket: {
                has_expiration: {
                    $set: !this.state.ticket.has_expiration
                }
            }
        });
        this.setState(has_expiration);
    };

    handleIsActive = () => {
        let is_active = update(this.state, {
            ticket: {
                is_active: {
                    $set: !this.state.ticket.is_active
                }
            }
        });
        this.setState(is_active);
    };

    handleClose = () => {
        this.props.ticketDialog({open: false, ticket:{id:null, name:' ', price:0, has_expiration:false, expiration_days:0}});
    };

    dispatchData = (ticket, message) => {
        this.props.showToast({message: message, type: 'success'});
        this.props.selectTicket(ticket);
        this.props.ticketDialog({open:true, ticket});
    };

    render() {
        return (
            <div>
                <Modal size='large' dimmer='inverted' open={this.props.ticket_dialog.open} onClose={this.handleClose}>
                    <Modal.Header>{this.props.ticket_dialog.ticket.id ? 'Actualizar Tiquetera':'Nueva Tiquetera'}</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Form>
                                <Grid divided>
                                    <Grid.Row>
                                        <Grid.Column mobile={16} computer={8}>
                                            <Form.Input label='Nombre' placeholder='Nombre' value={this.state.ticket.name} onChange={this.handleNameChange} error={this.state.ticket.name === ""} required/>
                                            <Form.Input
                                                label='Precio'
                                                error={this.state.price_error}
                                                required
                                                children={
                                                    <MaskedInput
                                                        mask={moneyMask}
                                                        value={this.state.ticket.price}
                                                        placeholder='Precio'
                                                        required
                                                        onChange={this.handlePriceChange}
                                                    />
                                                }
                                            />
                                            <Form.Checkbox label='¿Tiene caducidad?' checked={this.state.ticket.has_expiration} onChange={this.handleHasExpiration} />
                                            <Form.Input label='Días de caducidad' disabled={!this.state.ticket.has_expiration} placeholder='Días de caducidad' type='number' value={this.state.ticket.expiration_days} onChange={this.handleExpirationDaysChange} error={this.state.ticket.expiration_days < 0} />
                                            <Form.Checkbox label='Activa' checked={this.state.ticket.is_active} onChange={this.handleIsActive} />
                                        </Grid.Column>
                                        <Grid.Column mobile={16} computer={8}>
                                            <TicketProducts />
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Form>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleClose} content={this.props.ticket_dialog.ticket.id ? 'Cerrar':'Cancelar'}/>
                        <Button primary icon='save' disabled={this.state.sending} loading={this.state.sending} labelPosition='left' onClick={this.handleSubmit} content={this.props.ticket_dialog.ticket.id ? 'Actualizar':'Guardar'} />
                    </Modal.Actions>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        ticket_dialog: state.get('ticket_dialog'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        ticketDialog(data) {
            dispatch(ticketDialog(data));
        },
        showToast(data){
            dispatch(showToast(data))
        },
        selectTicket(data){
            dispatch(selectTicket(data))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TicketDialog);


// WEBPACK FOOTER //
// ./src/components/services/TicketDialog.js